// extracted by mini-css-extract-plugin
export default {"emptyStateGrid":"EmptyStatePage_emptyStateGrid__UYQhi"};